import React, { useState } from 'react';
import axios from 'axios';
const API = 'https://app.recensement-enfantsnonproteges.fr';
export default function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const login = async () => {
    try {
      const r = await axios.post(API+'/api/admin/login', { username, password });
      localStorage.setItem('recensement_token', r.data.token);
      onLogin(r.data.token);
    } catch(e) { setError('Identifiants incorrects'); }
  };
  return (
    <div className="login-page">
      <h2>Accès admin</h2>
      {error && <div className="login-error">{error}</div>}
      <div className="field"><label className="lbl">Identifiant</label><input type="text" value={username} onChange={e => setUsername(e.target.value)} /></div>
      <div className="field"><label className="lbl">Mot de passe</label><input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key==='Enter' && login()} /></div>
      <button className="btn-red" style={{width:'100%',marginTop:'8px'}} onClick={login}>Se connecter</button>
    </div>
  );
}
